import request from '@/utils/request'

// 获取首页资讯列表
export const homePageController = () => {
  return request({
    url: '/ctep/homePage/list',
    method: 'get'
  })
}
// 获取新闻列表
export const newsList = (params) => {
  return request({
    url: '/ctep/news/list',
    method: 'get',
    params: params
  })
}
// 获取新闻列表
export const newsDetail = (id) => {
  return request({
    url: `/ctep/news/${id}`,
    method: 'get'
  })
}
// 获取友情链接列表
export const linkList = () => {
  return request({
    url: '/ctep/link/list',
    method: 'get'
  })
}
